// Mirrors src/util/subscriptionEligibility.ts on the backend. Deny/undeny
// redeem through their own special-cased flow (CreateReinDeny) rather than
// the generic custom-tip path subscriptions renew through, so they can never
// be made subscribable - the server rejects it either way, but disabling the
// toggle here means a broadcaster never gets into that state in the first
// place, and a tipper never sees a Subscribe button that's guaranteed to
// fail.
export const NON_SUBSCRIBABLE_TYPES = ["deny", "undeny"];

export const isSubscribableType = (type?: string | null) =>
  !!type && !NON_SUBSCRIBABLE_TYPES.includes(type);
